import { Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DefaultActionFactory, DefaultActionFactoryToken } from "@core/redux/redux.module";
import { Store } from "@ngrx/store";
import { DEFAULT_STATE_NAME } from "@core/redux/reducer/default/default.reducer";
import { Observable, Subject } from "rxjs";
import { ResourceService, ResourceServiceToken } from "@feature_core/resource/resource.module";
import { LocalStoreService } from "../../../core/index";
import { FormatterService, FormatterServiceToken } from "@core/formatter/service/formatter.service";
import { takeUntil } from "rxjs/operators";
import { DigitOnlyInputDirective } from "@core/directive/digit-only-input.directive";
import {
  SessionManagerService,
  SessionManagerServiceToken
} from "@feature_core/session/session.module";

@Component({
  templateUrl: "./sign.component.html"
})

export class SignComponent implements OnInit, OnDestroy {

  @ViewChild(DigitOnlyInputDirective) tokenRef: DigitOnlyInputDirective;

  private _destroy$: Subject<boolean> = new Subject<boolean>();
  public signFormGroup: FormGroup;
  private actionFactory: DefaultActionFactory;
  private defaultState: Observable<any>;
  private cardPhoneNumber: string;
  public ownersPhone: string;
  public TOKEN_LENGTH = 6;

  constructor(
    private formBuilder: FormBuilder,
    protected router: Router,
    @Inject(DefaultActionFactoryToken)
      defaultActionFactory: DefaultActionFactory,
    @Inject(ResourceServiceToken) resourceService: ResourceService,
    @Inject(FormatterServiceToken) formatterService: FormatterService,
    @Inject(SessionManagerServiceToken) protected _sessionManager: SessionManagerService,
    ngStore: Store<any>
  ) {
    this.defaultState = ngStore.select(DEFAULT_STATE_NAME);
    this.defaultState.subscribe( state => {
      this.cardPhoneNumber = state.cardPhoneNumber || LocalStoreService.get()?.cardPhoneNumber;
      this.ownersPhone = this.cardPhoneNumber;
    });
    this.actionFactory = defaultActionFactory;
    this.signFormGroup = this.formBuilder.group({
      token: [null, [Validators.required, Validators.minLength(this.TOKEN_LENGTH), Validators.maxLength(this.TOKEN_LENGTH)]]
    });
  }

  ngOnInit(): void {
    this._sessionManager.restoreTimeOuts();
  }

  ngOnDestroy() {
    this._destroy$.next(true);
    this._destroy$.unsubscribe();
  }

  public submit() {
    this.signFormGroup.get("token").setErrors(null);
    this.signFormGroup.get("token").updateValueAndValidity();
    if (this.signFormGroup.valid) {
      this.actionFactory.confirmLogin({
        confirmationCode: this.signFormGroup.get("token").value
      }).pipe(
        takeUntil(this._destroy$)
      ).subscribe( resp => {
        this.router.navigate(["mkb3ds", "modify"]);
      }, error => {
        this.signFormGroup.get("token").setErrors({"backenderror" : true});
      });
    }
  }

  public sendNewToken() {

    this.token.setErrors(null);
    this.token.reset();
    this.signFormGroup.reset({ token: null }, { emitEvent: false});
    this.tokenRef.resetValue();

    this.actionFactory.resendConfirmationCode({
      cardPhoneNumber: this.cardPhoneNumber
    }).pipe(
      takeUntil(this._destroy$)
    ).subscribe( resp => {}, error => {
      // a kívánt működés nem ismert
    });
  }

  get token(): any { return this.signFormGroup.get("token"); }
}
